export const engagementAppGroupIdPresetBannerTemplatesId = "/engagement/:app_group_id/preset_banner_templates/:id";
